import { bindRequestLogic } from './utils'
import LogSwitchToTypes from '../actionTypes/logSwitchTo'
import { logSwitchToAPI } from '../api'

const getLogSwitchTo = bindRequestLogic({
  clientFunc: logSwitchToAPI.getLogSwitchTo,
  type: LogSwitchToTypes.GET_LOG_SWITCH_TO_REQUEST,
  successType: LogSwitchToTypes.GET_LOG_SWITCH_TO_SUCCESS,
  failType: LogSwitchToTypes.GET_LOG_SWITCH_TO_FAILED,
  isQueryParam: true
})

export default [getLogSwitchTo]
